export default __webpack_public_path__ + "static/media/Employees_TINETTI.a86680ab.pdf";